import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const LangSmithIntegration = React.lazy(() => import("./LangSmithIntegration"));

interface LangSmithIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function LangSmithIntegrationLazy(props: LangSmithIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <LangSmithIntegration {...props} />
    </Suspense>
  );
}
